<template>
  <v-row
    no-gutters
    class=" align-center element justify-space-between flex-nowrap"
    :class="classes"
    :style="{ 'background-color': backgroundColor }"
  >
    <v-col class="handleDrag">
      <v-row no-gutters class="flex-nowrap align-center">
        <v-col cols="auto" v-if="level > 1 || isRight">
          <img
            v-if="layerStyle && layerStyle.externalGraphic"
            width="20px"
            height="20px"
            :src="getIcon(layerStyle.externalGraphic)"
            class="ml-1 mt-2"
            :class="$attrs.disabled ? 'disabledIcon' : ''"
          />
          <legend-layer-list-icon
            v-else
            :class="$attrs.disabled ? 'disabledIcon' : ''"
            :color="getIconColor(layerStyle)"
            :layer-type="getLayerType(layer)"
          ></legend-layer-list-icon>
        </v-col>
        <v-col cols="auto">
          <div
            class="text-truncate text-body-2 flex-shrink-0"
            :class="{ 'pl-2': level > 1 || isRight }"
            style="padding-top: 2px;"
          >
            {{ name }}
          </div>
        </v-col>
        <slot name="appendName" v-bind="{ ...$props, ...$attrs }" />
        <v-col cols="auto" v-if="cacheSwitcher && hasCache && level > 1">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <span v-on="on">
                <data-input
                  :data-type="{
                    name: 'switch',
                  }"
                  dense
                  hide-details
                  :value="cache"
                  @change="changeCache"
                ></data-input>
              </span>
            </template>
            {{ cache ? $i18n.t('admin.switchOffCacheLayer') : $i18n.t('admin.switchOnCacheLayer') }}
          </v-tooltip>
        </v-col>
      </v-row>
      <div></div>
    </v-col>
    <v-col cols="auto" v-if="(!isRight && level === 1) || (hasLayerDotsItems && !isRight && level === 2)">
      <dots-menu :disabled="$attrs.disabled" font-size="19px" :items="dotsItems" v-on="listeners" />
    </v-col>
  </v-row>
</template>

<script>
import LegendLayerListIcon from '@/components/LegendLayerListIcon';
import DotsMenu from '@/components/DotsMenu';
import DataInput from '@/components/DataInput';
import { call, get } from 'vuex-pathify';

export default {
  name: 'DraggableListsMobileLayersItem',
  components: {
    LegendLayerListIcon,
    DotsMenu,
    DataInput,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      required: true,
    },
    dotsItems: {
      type: Array,
      default: () => [
        {
          name: 'changeGroupName',
        },
        {
          name: 'delete',
        },
      ],
    },
    hasLayerDotsItems: {
      type: Boolean,
      default: false,
    },
    cache: {
      type: Boolean,
      default: false,
    },
    cacheSwitcher: {
      type: Boolean,
      default: false,
    },
    group_id: {
      type: [Number, String],
    },
    scope: {
      type: String,
      default: 'core',
    },
    schema_scope: {
      type: String,
    },
    hasCache: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    layer: get('layers/layers@:id'),
    layerStyle() {
      if (this.layer) {
        return this.layer.style_web;
      }
      return undefined;
    },
    backgroundColor() {
      return this.level > 1 ? 'rgb(231, 231, 231, 0.5)' : 'white';
    },
    classes() {
      if (this.isRight) {
        return ['border', 'px-4'];
      }
      return this.level > 1 ? [`px-${this.level * 2}`, 'border'] : [];
    },
    listeners() {
      const listeners = {};
      for (const dotsItem of this.dotsItems) {
        listeners[dotsItem.name] = () => {
          this.$emit(dotsItem.name, this.$props);
        };
      }
      return listeners;
    },
  },
  methods: {
    attachLayerGroup: call('layers/attachLayerGroup'),
    getLayerType(layer) {
      return layer.type === 'features_layer' || layer.type === 'dynamic_features_layer'
        ? layer.geometry_type
        : layer.service_type;
    },
    getIconColor(style) {
      if (style) {
        return style['fill-color'] || style['circle-color'] || style['line-color'] || 'green';
      } else {
        return 'grey';
      }
    },
    getIcon(name) {
      return `${process.env.VUE_APP_API_URL}/icons/${name}`;
    },
    changeCache(value) {
      this.attachLayerGroup({
        layer_id: this.id,
        body: {
          group_id: this.group_id,
          cache: value,
        },
        scope: this.scope,
        schema_scope: this.schema_scope,
      });
    },
  },
};
</script>

<style scoped lang="scss">
ul {
  padding-left: 0;
  list-style: none;
}
.element {
  height: 40px;
}
.border {
  margin-bottom: 4px;
  @include border(top);
  @include border(right);
  @include border(left);
  &:last-child {
    @include border(bottom);
  }
}
.disabledIcon {
  filter: grayscale(100%);
}
</style>
